export const DEFAULT_DEVIATION_COLORS = {
  positive_bg: '#ecfdf5',
  positive_text: '#059669',
  negative_bg: '#fef2f2',
  negative_text: '#dc2626',
} as const;

export const DEFAULT_HEADER_COLORS = {
  purple: '#9333ea',
  blue: '#3b82f6',
  orange: '#ea580c',
  green: '#059669',
} as const;

export const DEFAULT_BUTTON_TEXTS = {
  save: 'Сохранить',
  reload: 'Обновить',
  export: 'Экспорт в Excel',
  add_row: 'Добавить строку',
  cancel: 'Отмена',
} as const;

export const COLOR_PRESETS = [
  '#9333ea', '#3b82f6', '#ea580c', '#059669',
  '#dc2626', '#f59e0b', '#6366f1', '#ec4899',
  '#14b8a6', '#8b5cf6', '#f97316', '#06b6d4',
];
